module.exports = __webpack_public_path__ + "assets/img/play-video.f8d1b4ba.svg";